(() => {
  const root = document.querySelector('[data-scent-finder]');
  if (!root) return;

  const catalogEl = root.querySelector('[data-sf-catalog]');
  let catalog = [];
  try { catalog = JSON.parse(catalogEl.textContent); } catch (e) { catalog = []; }

  const FAMILY_KEYWORDS = {
    floral: ['floral', 'rose', 'jasmine', 'peony', 'iris', 'ylang', 'freesia', 'lotus', 'magnolia', 'orchid', 'hibiscus', 'violet', 'white floral', 'orange blossom', 'tuberose', 'poppy', 'lily', 'blossom', 'powder'],
    fresh: ['fresh', 'aquatic', 'marine', 'ocean', 'sea salt', 'sea notes', 'coastal', 'breezy', 'icy', 'crisp', 'clean', 'water', 'citrus', 'bergamot', 'lemon', 'lime', 'neroli', 'yuzu', 'orange', 'blood orange', 'mandarin', 'petitgrain', 'grapefruit', 'sporty', 'vacation'],
    'sweet-gourmand': ['vanilla', 'caramel', 'praline', 'honey', 'gourmand', 'chocolate', 'cocoa', 'coffee', 'sugar', 'tonka', 'almond', 'sweet', 'cherry', 'peach', 'rum', 'hazelnut', 'cacao', 'nutty', 'milky', 'creamy', 'sugar cane', 'licorice'],
    'green-aromatic': ['green', 'aromatic', 'herbal', 'herb', 'lavender', 'mint', 'minty', 'basil', 'sage', 'rosemary', 'thyme', 'fig leaf', 'galbanum', 'tea', 'verbena', 'geranium', 'cypress'],
    'woody-earthy': ['woody', 'wood', 'sandalwood', 'cedarwood', 'cedar', 'vetiver', 'patchouli', 'oakmoss', 'moss', 'birch', 'rosewood', 'fir', 'pine', 'suede', 'oud', 'agarwood', 'leather', 'earthy'],
    'warm-spicy': ['amber', 'incense', 'spicy', 'saffron', 'resin', 'myrrh', 'tobacco', 'smoky', 'smoke', 'oriental', 'cinnamon', 'cardamom', 'pepper', 'clove', 'labdanum', 'ambergris', 'ambroxan', 'warm', 'spice']
  };

  const VALID_FAMILIES = { floral: 1, fresh: 1, 'sweet-gourmand': 1, 'green-aromatic': 1, 'woody-earthy': 1, 'warm-spicy': 1 };
  const VALID_INTENSITY = { soft: 1, significant: 1, statement: 1 };

  const SEASON_KEYWORDS = {
    summer: ['summer', 'spring', 'fresh', 'aquatic', 'marine', 'citrus', 'beach', 'tropical', 'coastal', 'icy', 'breezy', 'vacation', 'light'],
    winter: ['fall winter', 'winter', 'fall', 'cozy', 'warm', 'smoky', 'oud', 'leather', 'amber', 'spicy', 'tobacco', 'gourmand', 'sweet'],
    all: ['all season', 'all-season', 'daily wear', 'signature', 'everyday', 'versatile']
  };

  const INTENSITY_KEYWORDS = {
    soft: ['soft', 'light', 'skin scent', 'subtle', 'gentle', 'clean', 'smooth', 'delicate', 'breezy', 'intimate'],
    significant: ['significant', 'moderate', 'medium', 'balanced', 'present', 'versatile', 'everyday', 'signature', 'daily wear', 'noticeable'],
    statement: ['statement', 'bold', 'powerful', 'intense', 'strong', 'heavy', 'dramatic', 'rich', 'long lasting', 'long-lasting', 'extrait', 'night', 'projection', 'beast']
  };

  const FEMALE_HINTS = ['feminine', 'women', "women's", 'gift for her', 'romantic', 'her scent', 'floral fruity', 'pretty'];
  const MALE_HINTS = ['masculine', 'mens', "men's", 'men extrait', 'gift for him', 'cologne', 'men signature', 'mens signature'];
  const UNISEX_HINTS = ['unisex', 'gender neutral'];

  const norm = (s) => (s || '').toLowerCase();

  const scoreSet = (tags, keywords) => {
    let score = 0;
    for (const kw of keywords) {
      for (const t of tags) {
        if (t.indexOf(kw) !== -1) { score += 1; break; }
      }
    }
    return score;
  };

  const topKey = (tags, sets, fallback) => {
    let best = fallback, bestScore = 0;
    for (const key in sets) {
      const s = scoreSet(tags, sets[key]);
      if (s > bestScore) { bestScore = s; best = key; }
    }
    return best;
  };

  const classify = (p) => {
    const tags = (p.tags || []).map(norm);
    const blob = tags.join(' ') + ' ' + norm(p.title);

    let family = VALID_FAMILIES[p.familyMeta] ? p.familyMeta : topKey(tags, FAMILY_KEYWORDS, 'warm-spicy');

    let gender = p.gender;
    if (gender !== 'women' && gender !== 'men' && gender !== 'unisex') {
      const f = FEMALE_HINTS.some((h) => blob.indexOf(h) !== -1);
      const m = MALE_HINTS.some((h) => blob.indexOf(h) !== -1);
      const u = UNISEX_HINTS.some((h) => blob.indexOf(h) !== -1);
      if (u) gender = 'unisex';
      else if (f && !m) gender = 'women';
      else if (m && !f) gender = 'men';
      else gender = 'unisex';
    }

    const season = topKey(tags, SEASON_KEYWORDS, 'all');
    const intensity = VALID_INTENSITY[p.intensityMeta] ? p.intensityMeta : topKey(tags, INTENSITY_KEYWORDS, 'significant');

    return Object.assign({}, p, { family, gender, season, intensity });
  };

  const classified = catalog.map(classify);

  const answers = { gender: null, season: null, family: null, intensity: null };
  let stepIndex = 0;
  const steps = root.querySelectorAll('[data-sf-step]');
  const progressEl = root.querySelector('[data-sf-progress]');

  const showStep = (i) => {
    steps.forEach((s, idx) => s.hidden = idx !== i);
    if (progressEl) progressEl.style.width = ((i) / steps.length) * 100 + '%';
    root.querySelector('[data-sf-result]').hidden = true;
    stepIndex = i;
  };

  const score = (p) => {
    let s = 0;
    if (answers.gender && (p.gender === answers.gender || answers.gender === 'unisex' || p.gender === 'unisex')) s += 4;
    if (answers.family && p.family === answers.family) s += 5;
    if (answers.season && (p.season === answers.season || p.season === 'all')) s += 2;
    if (answers.intensity && p.intensity === answers.intensity) s += 2;
    return s;
  };

  const genderRank = (p) => {
    if (!answers.gender || answers.gender === 'unisex') return 0;
    if (p.gender === answers.gender) return 0;
    if (p.gender === 'unisex') return 1;
    return 2;
  };

  const pickMatches = () => {
    let pool = classified.slice();
    if (answers.gender && answers.gender !== 'unisex') {
      const strict = pool.filter((p) => p.gender === answers.gender || p.gender === 'unisex');
      if (strict.length >= 4) pool = strict;
    }
    const ranked = pool
      .map((p) => ({ p, s: score(p), g: genderRank(p) }))
      .sort((a, b) => (a.g - b.g) || (b.s - a.s));
    const top = ranked.filter((r) => r.s > 0).slice(0, 6).map((r) => r.p);
    if (top.length >= 3) return top;
    return ranked.slice(0, 6).map((r) => r.p);
  };

  const money = (cents) => {
    const v = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return '$' + v;
  };

  const renderResults = () => {
    const matches = pickMatches();
    const grid = root.querySelector('[data-sf-matches]');
    grid.innerHTML = '';
    matches.forEach((p) => {
      const card = root.querySelector('[data-sf-pool-card="' + p.handle + '"] .ibscent-coll-card');
      if (card) grid.appendChild(card.cloneNode(true));
    });
    if (progressEl) progressEl.style.width = '100%';
    steps.forEach((s) => (s.hidden = true));
    const result = root.querySelector('[data-sf-result]');
    result.hidden = false;
    result.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const advance = () => {
    if (stepIndex < steps.length - 1) {
      showStep(stepIndex + 1);
    } else {
      const loader = root.querySelector('[data-sf-loading]');
      if (loader) {
        loader.hidden = false;
        steps.forEach((s) => (s.hidden = true));
        setTimeout(() => { loader.hidden = true; renderResults(); }, 1400);
      } else {
        renderResults();
      }
    }
  };

  root.addEventListener('click', (e) => {
    const opt = e.target.closest('[data-sf-option]');
    if (opt) {
      const key = opt.getAttribute('data-sf-key');
      const val = opt.getAttribute('data-sf-option');
      answers[key] = val;
      const group = opt.closest('[data-sf-step]');
      group.querySelectorAll('[data-sf-option]').forEach((o) => o.classList.remove('is-selected'));
      opt.classList.add('is-selected');
      setTimeout(advance, 220);
      return;
    }
    if (e.target.closest('[data-sf-restart]')) {
      answers.gender = answers.season = answers.family = answers.intensity = null;
      root.querySelectorAll('.is-selected').forEach((o) => o.classList.remove('is-selected'));
      showStep(0);
    }
    if (e.target.closest('[data-sf-back]') && stepIndex > 0) {
      showStep(stepIndex - 1);
    }
  });

  showStep(0);
})();
